import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadCart,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import {
    buildGA4ItemFromCartLine,
    getCurrencyCode,
    trackGA4AddToCart,
} from "@thkStore/Common/Utilities/ga4EcommerceTracking";

const SendGA4AddToCartEvent: typeof LoadCart = props => {
    if (!props.apiResult) {
        return;
    }

    const state = props.getState();
    const currency = getCurrencyCode(state);
    const item = buildGA4ItemFromCartLine(props.apiResult);
    const value = (props.apiResult.pricing?.unitNetPrice || 0) * (props.apiResult.qtyOrdered || 1);

    trackGA4AddToCart([item], currency, value);
};

addToChainAfter(chain, LoadCart, SendGA4AddToCartEvent);

if (module.hot) {
    module.hot.accept();
    const snapshotChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        snapshotChain.forEach(o => chain.push(o));
    });
}
